import { DisciplineOptions, FrequencyCadenceTypeOptions } from '@generated';
import { CheckboxField } from '~/shared/forms/controls/base-fields/CheckboxField';
import { DisciplineSelector } from '~/libraries/disciplines/DisciplineSelector';
import { SelectField } from '~/shared/forms/controls/base-fields/SelectField';
import { ButtonGroup } from '~/shared/forms/controls/base-controls/ButtonGroup';
import { Calendar, List } from 'lucide-react';
import clsx from 'clsx';
import { useEditFrequencies } from './EditFrequenciesContext';
import type { SelectedFrequencyView } from './wizardReducer';

//if you remove a frequency, you cant add a frequency with a different scheduled date and time same discipline, frequency type, cadence, and cadence correlator

export function EditFrequenciesToolbar() {
	const {
		wizardState: {
			loggedInUser,
			draftPrnFrequencies,
			selectedFrequencyView,
			selectedDisciplineId,
			displayAssignToMeCheckbox,
			assignCurrentUserToNewFrequencies,
			selectedCadenceTypeId
		},
		dispatch
	} = useEditFrequencies();

	return (
		<div className="flex flex-col gap-4">
			<div className="flex flex-wrap items-center gap-4">
				<ButtonGroup
					isSelected={(id: string) => selectedFrequencyView === id}
					onSelect={(id: string) => dispatch({ type: 'SET_SELECTED_FREQUENCY_VIEW', newSelectedView: id as SelectedFrequencyView })}
					options={[
						{ id: 'calendar', label: 'Calendar', Icon: Calendar },
						{ id: 'list', label: 'List', Icon: List },
						{ id: 'prn', label: `PRN (${draftPrnFrequencies.length})` }
					]}
				/>
				{selectedFrequencyView === 'calendar' && (
					<DisciplineSelector
						disciplineOptions={DisciplineOptions}
						selectedDisciplineId={selectedDisciplineId}
						setSelectedDisciplineId={disciplineId => dispatch({ type: 'SET_SELECTED_DISCIPLINE_ID', disciplineId })}
					/>
				)}
			</div>
			{selectedFrequencyView === 'calendar' && (
				<div className={clsx('flex items-center', displayAssignToMeCheckbox ? 'justify-between' : 'justify-end')}>
					{displayAssignToMeCheckbox && (
						<CheckboxField
							value={assignCurrentUserToNewFrequencies}
							isDisabled={selectedDisciplineId !== loggedInUser.clinicalTypeDisciplineId}
							onChange={() => dispatch({ type: 'TOGGLE_ASSIGN_TO_ME' })}
							label="Assign new frequencies to me"
							hideLabel
							className="text-base"
						/>
					)}
					<SelectField
						label="Frequency Cadence"
						density="compact"
						value={selectedCadenceTypeId}
						items={FrequencyCadenceTypeOptions}
						onChange={value => dispatch({ type: 'SET_SELECTED_CADENCE_TYPE_ID', frequencyCadenceTypeId: Number(value!) })}
						orientation="horizontal"
					/>
				</div>
			)}
		</div>
	);
}
